import { render, staticRenderFns } from "./Bandligi.vue?vue&type=template&id=264bf443"
import script from "./Bandligi.vue?vue&type=script&lang=js"
export * from "./Bandligi.vue?vue&type=script&lang=js"
import style0 from "./Bandligi.vue?vue&type=style&index=0&id=264bf443&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports